import config from 'message-control/config'

const ewechatMsgApi = `${config.apiHost}/oem-ewechat_msg`

export default {
    sessions: {
        url: `${ewechatMsgApi}/api/track/msg`,
        type: 'POST',
    },
    groupSessions: {
        url: `${ewechatMsgApi}/api/room_msg/room/track`,
        type: 'GET',
    },
    exportMessage: {
        url: `${ewechatMsgApi}/api/chat_msg/export`,
        type: 'GET',
    },
}
